import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { BANNER_COLOR_LIGHT } from "../pages/root";

const AccordionComponent = ({ accordionInfo, expandedAppId, onChange }) => {
  return (
    <>
      {accordionInfo.map((item) => {
        const isControlled = expandedAppId !== undefined && typeof onChange === "function";

        const isExpanded = expandedAppId === item.key;

        return (
          <Accordion
            key={item.key || item.title}
            expanded={isControlled ? isExpanded : undefined}
            onChange={isControlled ? () => onChange(isExpanded ? null : item.key) : undefined}
            sx={item.accordionSx}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel-${item.key}-content`}
              id={`panel-${item.key}-header`}
              sx={[
                {
                  backgroundColor: BANNER_COLOR_LIGHT,
                  borderRadius: "4px",
                },
                ...(item.summarySx ? [item.summarySx] : []),
              ]}
            >
              {item.title}
            </AccordionSummary>

            <AccordionDetails>{item.details}</AccordionDetails>
          </Accordion>
        );
      })}
    </>
  );
};

export default AccordionComponent;
